import { CustomPage } from '@app/components/custom-screen/CustomPage';
import { AppRoute } from '@app/core/routing/AppRoute';
import { DefaultYoutubeNativeStationRedirect } from '@app/core/routing/DefaultYoutubeNativeStationRedirect';
import { AdminRoutes } from '@app/modules/admin/routing/AdminRoutes';
import { ComposeRoutes } from '@app/modules/compose/routing/ComposeRoutes';
import { FragmentsRoutes } from '@app/modules/fragments/routing/FragmentsRoutes';
import { LivePlayerRoutes } from '@app/modules/live-player/LivePlayerRoutes';
import LoggerRoutes from '@app/modules/logger/LoggerRoutes';
import { YoutubeBroadcastsListStationPage } from '@app/modules/logger/screens/stream/youtube/broadcasts/list/YoutubeBroadcastsListStationPage';
import { youtubeBroadcastsListRouteGenerator } from '@app/modules/logger/screens/stream/youtube/broadcasts/list/youtube-broadcasts-list-routes';
import { SearchRoutes } from '@app/modules/search/routing/SearchRoutes';
import { StreamerBoxRoutes } from '@app/modules/streamer-box/routing/StreamerBoxRoutes';
import { Redirect, Switch } from 'react-router-dom';
import { AssetsRoutes } from './assets/routing/AssetsRoutes';
import { AuditRoutes } from './audit/routing/AuditRoutes';
import { ContentAiRoutes } from './content-ai/routing/ContentAiRoutes';
import { SettingsRoutes } from './settings/routing/SettingsRoutes';

export function ModulesRoutes() {
  return (
    <Switch>
      <AppRoute path="/audit" component={AuditRoutes} />
      <AppRoute path="/fragments" component={FragmentsRoutes} />
      <AppRoute path="/compose" component={ComposeRoutes} />
      <AppRoute path="/live-player" component={LivePlayerRoutes} />
      <AppRoute path="/logger" component={LoggerRoutes} />
      <AppRoute
        exact
        path="/youtube-broadcasts/s/:slug"
        component={YoutubeBroadcastsListStationPage}
      />
      <AppRoute
        exact
        path="/youtube-broadcasts"
        render={() => (
          <DefaultYoutubeNativeStationRedirect
            to={(slug) => youtubeBroadcastsListRouteGenerator.list(slug)}
          />
        )}
      />
      <AppRoute path="/streamer-box" component={StreamerBoxRoutes} />
      <AppRoute path="/admin" component={AdminRoutes} />
      <AppRoute path="/settings" component={SettingsRoutes} />
      <AppRoute path="/search" component={SearchRoutes} />
      <AppRoute path="/assets" component={AssetsRoutes} />
      <AppRoute path="/content-ai" component={ContentAiRoutes} />
      <AppRoute path="/_custom" component={CustomPage} />
      <Redirect to="/logger" />
    </Switch>
  );
}
